import {
    checkRegEx,
    checkForLengthAfterDot,
} from './checkerFunctions'

export default function helperhandleChange(e: any,
    regex: any,
    toFix: any,
    setinputStake: any,
    setnumber: any,
) {
    const n = e.target.value
    if (checkRegEx(n, regex)) {
        if (checkForLengthAfterDot(n, toFix)) {
            setinputStake(n.replace(/,/g, '.'))
            setnumber(n.replace(/,/g, '.'))
        }
    }
}

